import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * Usage:
 * const videoIds = ["dQw4w9WgXcQ", "M7lc1UVf-VE", "tgbNymZ7vqY"];
 * <VideoCarousel videoIds={videoIds} />
 */
const VideoCarousel = ({ videoIds }) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className="content">
      <h1>Video Gallery</h1>
    <div className="video-carousel">
      <Slider {...settings}>
        {videoIds.map((id, index) => (
          <div key={index} className="video-slide">
            <div className="video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${id}?rel=0`}
                title={`YouTube video ${index + 1}`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
    </div>
  );
};

export default VideoCarousel;
